import React from "react";
import Navbar from "./Sections/Navbar";
import ContactSection from "./Sections/ContactsSection";

const ContactPage = () => {
  return (
    <div>
      <Navbar />
      <ContactSection />
    </div>
  );
};

export default ContactPage;
